<ycn-modal-base
    [open]="isOpen()"
    (closeModalHandler)="onDismiss()">
    <ycn-simple-modal-header
        [header]="'Smart Compare'"
        (closeModalHandler)="onDismiss()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <div class="modal-section">
            <ycn-icon-search-autocomplete
                #autocompleter
                [searchType]="'quickflow_securities'"
                [placeholder]="'Add a security'"
                [appendToBody]="true"
                (submitHandler)="onAutocompleteSelect($event)" />
            <div class="text-muted mt-1">Compare {{ minItems }} to {{ maxItems }} securities.</div>
            <div class="d-flex flex-wrap mt-2">
                @for (item of items(); track item.securityId; let i = $index) {
                    <div class="btn btn-purple-tint mr-1 mb-1">
                        <div ycnTooltip [tooltipPlacement]="'left'" [tooltipTitle]="item.name">
                            {{ item.displaySecurityId }}
                        </div>
                        <div class="btn btn-xs btn-circle btn-transparent btn-close" (click)="removeItem(i)">
                            <span><svg ycnIcon [name]="'icon-close-circle'"></svg></span>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
    <ycn-simple-modal-footer
        [disableSubmission]="!canSubmit()"
        (cancelHandler)="onDismiss()"
        [submitButtonText]="'Compare'"
        (submitHandler)="submit()">
    </ycn-simple-modal-footer>
</ycn-modal-base>
